import { createGlobalStyle } from 'styled-components'

import prev from './Back.svg'
import close from './Close.svg'
import next from './Next.svg'

/* react-image-lightbox custom styles */
const LightboxStyles = createGlobalStyle`
  .ReactModal__Body--o_outer {
    background-color: rgba(0, 0, 0, 0.85);
  }

  .ReactModal__Body--open .ril__toolbar {
    background-color: transparent;
    height: 0;
  }

  .ReactModal__Body--open .ril-toolbar-right .ril__toolbarItem {
    margin-top: 50px;
    margin-right: 30px;
    background: url(${close});
    background-repeat: no-repeat;
    width: 50px;
    height: 50px;
  }

  .ReactModal__Body--open .ril-toolbar-right .ril__closeButton {
    background: transparent;
  }

  .ReactModal__Body--open .ril-toolbar-right .ril__toolbarItem:not(:last-child) {
    display: none;
  }

  .ReactModal__Body--open .ril-toolbar-right .ril__toolbarItem:last-child {
    display: inline-block;
  }

  .ril__navButtons {
    opacity: 1;
  }

  .ril__navButtons:hover {
    opacity: 0.8;
  }

  .ril__navButtonPrev {
    background: url(${prev});
    background-repeat: no-repeat;
    background-size: 50px 50px;
    width: 50px;
    height: 50px;
    margin-left: 15px;
  }

  .ril__navButtonNext {
    background: url(${next});
    background-repeat: no-repeat;
    background-size: 50px 50px;
    width: 50px;
    height: 50px;
    margin-right: 15px;
  }

  .ril__closeButton, .ril__navButtonPrev:focus, .ril__navButtonNext:focus {
    outline: 0;
  }

  .ril__outerAnimating {
    animation-duration: 100ms !important;
    transition: none !important;
  }

  @media only screen and (max-width: 1096px) {
    .ReactModal__Body--open .ril-toolbar-right .ril__toolbarItem {
      margin-right: 0;
    }
  }

  @media only screen and (max-width: 767px) {
    .ril__navButtonPrev {
      display: none;
    }
    .ril__navButtonNext {
      display: none;
    }
  }
`

export default LightboxStyles
